export default import.meta.glob('~~/common/aw_icons/src/loyalty/*.svg', { query: '?raw', import: 'default', eager: true });
